var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'desktop-mode': _vm.isDesktop },attrs:{"id":"app"}},[(_vm.isDesktop)?_c('div',{staticClass:"desktop-drag-bar",class:{ 'drag-bar-login': _vm.isLogin }}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }